import React from 'react';
import {
    Box,
    Chip,
    IconButton,
    TableCell,
    TableRow,
    Tooltip,
    Typography,
} from "@mui/material";
import { DeleteOutlineRounded, GroupWorkRounded } from "@mui/icons-material";

const _GroupTableRow = ({ row, onDeleteClick }) => {
    const hasMembers = (row?.UserCount || 0) > 0;

    return (
        <TableRow
            hover
            sx={{
                transition: 'background-color 0.15s ease',
                '&:last-child td, &:last-child th': { border: 0 }
            }}
        >
            <TableCell>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Box
                        sx={{
                            width: 36,
                            height: 36,
                            borderRadius: 2,
                            bgcolor: 'rgba(28, 139, 156, 0.08)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'primary.main'
                        }}
                    >
                        <GroupWorkRounded sx={{ fontSize: 20 }} />
                    </Box>
                    <Typography variant="body2" sx={{ fontWeight: 800, color: 'text.primary' }}>
                        {row?.Name || "بدون نام"}
                    </Typography>
                </Box>
            </TableCell>

            <TableCell>
                <Chip
                    size="small"
                    label={`${row?.UserCount || 0} نفر`}
                    variant="outlined"
                    sx={{
                        borderRadius: 1.8,
                        fontWeight: 700,
                        fontSize: '0.75rem',
                        borderColor: hasMembers ? 'primary.main' : 'divider',
                        color: hasMembers ? 'primary.main' : 'text.secondary',
                        bgcolor: hasMembers ? 'rgba(28, 139, 156, 0.06)' : 'transparent'
                    }}
                />
            </TableCell>

            <TableCell align="left">
                <Tooltip
                    title={
                        hasMembers
                            ? "امکان حذف گروه دارای عضو وجود ندارد"
                            : "حذف این گروه"
                    }
                >
                    <span>
                        <IconButton
                            size="small"
                            disabled={hasMembers}
                            onClick={() => onDeleteClick(row)}
                            sx={{
                                color: 'error.main',
                                bgcolor: hasMembers ? 'transparent' : 'rgba(239, 68, 68, 0.08)',
                                '&:hover': {
                                    bgcolor: 'error.main',
                                    color: 'white'
                                }
                            }}
                        >
                            <DeleteOutlineRounded fontSize="small" />
                        </IconButton>
                    </span>
                </Tooltip>
            </TableCell>
        </TableRow>
    );
};

export default _GroupTableRow;
